<div class="progress-spinner" *ngIf="display">
    <div class="spinner-container">
        <p-progressSpinner styleClass="custom-spinner" [strokeWidth]="strokeWidth"></p-progressSpinner> 
    </div>  
</div>